import { Box, Skeleton } from "@mui/material";
import React from "react";

export const TableLoadingState = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        pt: 5.5,
        width: "100%",
        height: "100vh",
      }}
    >
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
      <Skeleton variant="rounded" animation="wave" width="100%" height="10%" />
    </Box>
  );
};
